import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PrivateComponent() {
    const { isAuthenticated, isLoading } = useAuth();
    if (isLoading) {
        return <div className="auth-loading">Loading...</div>;
    }
    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
}
